interface ContentEntryFormProps {
  content: string;
  sourceUrl: string;
  operatorNotes: string;
  confidenceLevel: 'high' | 'medium' | 'low';
  onContentChange: (value: string) => void;
  onSourceUrlChange: (value: string) => void;
  onOperatorNotesChange: (value: string) => void;
  onConfidenceLevelChange: (value: 'high' | 'medium' | 'low') => void;
}

export function ContentEntryForm({
  content,
  sourceUrl,
  operatorNotes,
  confidenceLevel,
  onContentChange,
  onSourceUrlChange,
  onOperatorNotesChange,
  onConfidenceLevelChange,
}: ContentEntryFormProps) {
  return (
    <div style={{ 
      backgroundColor: 'white',
      borderRadius: '8px',
      padding: '16px',
      border: '1px solid #e5e7eb'
    }}>
      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>
          Source URL
        </label>
        <input
          type="url"
          placeholder="https://example.com/awards"
          value={sourceUrl}
          onChange={(e) => onSourceUrlChange(e.target.value)}
          style={{
            width: '100%',
            padding: '8px',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            fontSize: '14px'
          }}
        />
        <p style={{ marginTop: '4px', fontSize: '12px', color: '#6b7280' }}>
          The URL where this content was found (optional but recommended)
        </p>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>
          Raw Content
        </label>
        <textarea
          placeholder="Paste HTML, Markdown, or plain text content here..."
          value={content}
          onChange={(e) => onContentChange(e.target.value)}
          style={{
            width: '100%',
            minHeight: '400px',
            padding: '8px',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            fontSize: '13px',
            fontFamily: 'monospace',
            resize: 'vertical'
          }}
        />
        <p style={{ marginTop: '4px', fontSize: '12px', color: '#6b7280' }}>
          Paste the full webpage content, award categories list, or any relevant text
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
        <div>
          <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>
            Confidence Level
          </label>
          <select
            value={confidenceLevel}
            onChange={(e) => onConfidenceLevelChange(e.target.value as 'high' | 'medium' | 'low')}
            style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #d1d5db',
              borderRadius: '4px',
              fontSize: '14px',
              backgroundColor: 'white'
            }}
          >
            <option value="high">High - Complete and accurate</option>
            <option value="medium">Medium - Mostly complete</option>
            <option value="low">Low - Needs review</option>
          </select>
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>
            Operator Notes
          </label>
          <textarea
            placeholder="Any notes about this entry..."
            value={operatorNotes}
            onChange={(e) => onOperatorNotesChange(e.target.value)}
            style={{
              width: '100%',
              minHeight: '80px',
              padding: '8px',
              border: '1px solid #d1d5db',
              borderRadius: '4px',
              fontSize: '14px',
              resize: 'vertical'
            }}
          />
        </div>
      </div>
    </div>
  );
}